/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
export enum CreateGoalType {
  Custom = 'Custom',
  Template = 'Template',
}

export type TaskToCreate = {
  id: string
  title: string
  resourceId: string
  linkText: string
  linkUrl: string
}

export const FEEDBACK_TIMEOUT = 10000
